import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	pageTitle: {
		id: 'fastshift.migration-tickets-page.page-title',
		defaultMessage: 'Migration tickets',
		description: 'Page title for migration tickets page',
	},
	pageDescription: {
		id: 'fastshift.migration-tickets-page.page-description',
		defaultMessage:
			'View all migration tickets that you have access to. You can open a specific ticket to learn more about its status.',
		description: 'Page description for migration tickets page',
	},
	migrationTicketsTableSearchAriaLabel: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.search-aria-label',
		defaultMessage: 'Search by ticket ID, title',
		description: 'Aria label for the search input in the migration tickets table',
	},
	migrationTicketsTableTicketColumnTitle: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.ticket-column-title',
		defaultMessage: 'Ticket',
		description: 'Column title for the ticket column in the migration tickets table',
	},
	migrationTicketsTableStatusColumnTitle: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.status-column-title',
		defaultMessage: 'Status',
		description: 'Column title for the status column in the migration tickets table',
	},
	migrationTicketsTablePhaseColumnTitle: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.phase-column-title',
		defaultMessage: 'Phase',
		description: 'Column title for the phase column in the migration tickets table',
	},
	migrationTicketsTableSourceColumnTitle: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.source-column-title',
		defaultMessage: 'Source',
		description: 'Column title for the source column in the migration tickets table',
	},
	migrationTicketsTableDestinationColumnTitle: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.destination-column-title',
		defaultMessage: 'Destination',
		description: 'Column title for the destination column in the migration tickets table',
	},
	migrationTicketsTablePlanToMigrateDateColumnTitle: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.plan-to-migrate-date-column-title',
		defaultMessage: 'Plan to migrate',
		description: 'Column title for the plan to migrate date column in the migration tickets table',
	},
	migrationTicketsTableActionsColumnTitle: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.actions-column-title',
		defaultMessage: 'Actions',
		description: 'Column title for the actions column in the migration tickets table',
	},
	migrationTicketsTableMigrationPhaseExplore: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.migration-phase-explore',
		defaultMessage: 'Explore',
		description: 'Label for explore migration phase',
	},
	migrationTicketsTableMigrationPhaseAssess: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.migration-phase-assess',
		defaultMessage: 'Assess',
		description: 'Label for assess migration phase',
	},
	migrationTicketsTableMigrationPhasePlanAndTrack: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.migration-phase-plan-and-track',
		defaultMessage: 'Plan & Track',
		description: 'Label for plan and track migration phase',
	},
	migrationTicketsTableMigrationPhaseTestMigration: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.migration-phase-test-migration',
		defaultMessage: 'Test Migration',
		description: 'Label for test migration phase',
	},
	migrationTicketsTableMigrationPhaseProdMigration: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.migration-phase-prod-migration',
		defaultMessage: 'Prod Migration',
		description: 'Label for production migration phase',
	},
	migrationTicketsTableMigrationPhasePostMigration: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.migration-phase-post-migration',
		defaultMessage: 'Post-Migration',
		description: 'Label for post-migration phase',
	},
	migrationTicketsTableMigrationPhaseUnknown: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.migration-phase-unknown',
		defaultMessage: 'Unknown Phase',
		description: 'Fallback label for unknown migration phases to prevent UI crashes',
	},
	migrationTicketsTableErrorMessage: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.error-message',
		defaultMessage: 'We’re unable to retrieve the data about your migration progress.',
		description: 'Error message displayed when migration tickets fail to load',
	},
	migrationTicketsTableSourceDestinationColumnContentDefault: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.source-destination-column-content-default',
		defaultMessage: 'Atlassian product',
		description:
			'Column content for the source column and destination column in the migration status table when the product is unknown',
	},
	migrationTicketsTableSourceDestinationColumnContentNoBaseUrl: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.source-destination-column-content-no-base-url',
		defaultMessage: 'URL not available',
		description:
			'Column content for the source column and destination column in the migration status table when the source base URL is not available',
	},
	migrationTicketsTableNoDatePlanned: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.no-date-planned',
		defaultMessage: 'Pending',
		description:
			'Column content for the plan to migrate date column in the migration status table when the date is not available',
	},
	migrationTicketsTableJiraProductName: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.jira-product-name',
		defaultMessage: 'Jira',
		description: 'Column content for the Jira product name in the migration status table',
	},
	migrationTicketsTableConfluenceProductName: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.confluence-product-name',
		defaultMessage: 'Confluence',
		description: 'Column content for the Confluence product name in the migration status table',
	},
	migrationTicketsTableViewRelatedTicketsTooltip: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.view-related-tickets-tooltip',
		defaultMessage: 'View related tickets',
		description:
			'Tooltip and accessible label for the icon button that expands related tickets inline in the migration tickets table',
	},
	migrationTicketsTableRelatedTicketsExpandedTitle: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.related-tickets-expanded-title',
		defaultMessage: 'Related tickets',
		description: 'Title for the inline related tickets expanded row in the migration tickets table',
	},
	migrationTicketsTableNoRelatedTickets: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.no-related-tickets',
		defaultMessage: 'No related tickets.',
		description: 'Empty message for the inline related tickets expanded row',
	},
	migrationTicketsTableViewRunbooksTooltip: {
		id: 'fastshift.migration-tickets-page.migration-tickets-table.view-runbooks-tooltip',
		defaultMessage: 'View runbooks',
		description:
			'Tooltip and accessible label for the icon button that opens the runbooks side panel from the migration tickets table',
	},
});
